var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-title"},[_c('div',{staticClass:"page-title__title"},[_c('h1',{staticClass:"fs-32"},[_vm._v(_vm._s(_vm.$t(_vm.title)))]),_c('p',{staticClass:"fs-18"},[_vm._v(_vm._s(_vm.$t(_vm.subtitle)))])]),_c('div',{staticClass:"page-title__actions"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }